import {
  FETCH_ALL_USERS,
  SHOW_MESSAGE,
  FETCH_ALL_USERS_SUCCESS,
  SELECT_USER,
  EMPTY_SELECTED_USER,
  ADD_ADMIN_USER,
  ADD_ADMIN_USER_SUCCESS,
  ADD_ADMIN_USER_ERROR,
  ADD_ADMIN_USER_LOADING,
  EDIT_ADMIN_USER,
  EDIT_ADMIN_USER_SUCCESS,
  EDIT_ADMIN_USER_LOADING,
  EDIT_ADMIN_USER_ERROR,
  FETCH_ALL_PERMISSIONS,
  FETCH_ALL_PERMISSIONS_ERROR,
  FETCH_ALL_PERMISSIONS_SUCCESS,
  OPEN_USER_ROLE_DRAWER,
  FETCH_PERMISSIONS_BY_USERID,
  FETCH_PERMISSIONS_BY_USERID_SUCCESS,
  EMPTY_USER_ROLE,
  FETCH_PERMISSIONS_BY_USERID_ERROR,
  CLOSE_USER_ROLE_DRAWER,
  OPEN_EDIT_USER_DRAWER,
  OPEN_ADD_USER_DRAWER,
  CLOSE_EDIT_USER_DRAWER,
  LOADING_EDIT_ADMIN_USER,
  LOADING_ADD_ADMIN_USER,
  REMOVE_SHOW_ERROR_MESSAGE,
  REMOVE_SHOW_SUCESS_MESSAGE,
  CLOSE_ADD_USER_DRAWER,
  EMPTY_USERS,
} from "constants/ActionTypes";

export const fetchAllUsers = () => {
  return {
    type: FETCH_ALL_USERS,
  };
};
export const showUserMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message,
  };
};

export const fetchAllUsersResponse = (response) => {
  // console.log({response})
  // debugger
  if (response.data && response.status === 200)
    return fetchAllUsersSuccessSuccess(response.data);
  else return showUserMessage("An error occured");
};

export const fetchAllUsersSuccessSuccess = (response) => {
  if (typeof response === "undefined") return emptyUser();
  else if (response.data === null) {
    // debugger
    return emptyUser();
  } else if (response.state > 0 && response.data)
    return {
      type: FETCH_ALL_USERS_SUCCESS,
      payload: response.data,
    };
  else return showUserMessage(response.msg);
};

export const emptyUser = () => {
  return {
    type: EMPTY_USER,
  };
};
export const selectUser = (userId) => ({
  type: SELECT_USER,
  payload: userId,
});
export const emptySelectedUser = () => ({
  type: EMPTY_SELECTED_USER,
});
export const addAdminUser = ({
  FirstName,
  LastName,
  Email,
  Password,
  Username,
}) => {
  return {
    type: ADD_ADMIN_USER,
    payload: {
      Fullname: FirstName + " " + LastName,
      Email,
      Password,
      Username,
    },
  };
};
export const editAdminUser = ({
  FirstName,
  LastName,
  Email,
  Password,
  Username,
}) => {
  addAdminUserLoading();
  // 
  return {
    type: EDIT_ADMIN_USER,
    payload: {
      Fullname: FirstName + " " + LastName,
      Email,
      Password,
      Username,
    },
  };
};
export const addAdminUserSucess = (response) => ({
  type: ADD_ADMIN_USER_SUCCESS,
  payload: response.data,
});
export const editAdminUserSucess = (response) => ({
  type: EDIT_ADMIN_USER_SUCCESS,
  payload: response.data,
});
export const addAdminUserLoading = () => ({
  type: ADD_ADMIN_USER_LOADING,
});
export const editAdminUserLoading = () => ({
  type: EDIT_ADMIN_USER_LOADING,
});
export const addAdminUserError = (message = "") => ({
  type: ADD_ADMIN_USER_ERROR,
  payload: message,
});
export const editAdminUserError = (message = "") => ({
  type: EDIT_ADMIN_USER_ERROR,
  payload: message,
});
export const addAdminUserResponse = (response) => {
  if (response.data && response.status === 200)
    return addAdminUserSucess(response.data);
  else return addAdminUserError("An error occurred in adding admin user");
};
export const editAdminUserResponse = (response) => {
  // 
  if (response.data && response.status === 200)
    return editAdminUserSucess(response.data);
  else return editAdminUserError("An error occurred in adding admin user");
};

// export const fetchAllPermissions = () => ({
//   type: FETCH_ALL_PERMISSIONS,
// });

// export const fetchAllPermissionsError = (message = "") => ({
//   type: FETCH_ALL_PERMISSIONS_ERROR,
//   payload: message,
// });

// export const fetchAllPermissionsSuccess = () => ({
//   type: FETCH_ALL_PERMISSIONS_SUCCESS,
// });

// export const fetchAllPermissionsResponse = (response) => {
//   if (response.data && response.status === 200)
//     return fetchAllPermissionsSuccess(response.data);
//   else
//     return fetchAllPermissionsError("An error occurred in adding admin user");
// };

export const openUserRoleDrawer = () => ({
  type: OPEN_USER_ROLE_DRAWER,
});

export const closeUserRoleDrawer = () => ({
  type: CLOSE_USER_ROLE_DRAWER,
});

export const openEditUserDrawer = () => ({
  type: OPEN_EDIT_USER_DRAWER,
});

export const openAddUserDrawer = () => ({
  type: OPEN_ADD_USER_DRAWER
});
export const closeAddUserDrawer = () => ({
  type: CLOSE_ADD_USER_DRAWER
});

export const closeEditUserDrawer = () => ({
  type: CLOSE_EDIT_USER_DRAWER,
});

export const fetchPermissionsByUserId = (userId) => ({
  type: FETCH_PERMISSIONS_BY_USERID,
  payload: userId,
});

export const fetchPermissionsByUserIdResponse = (response) => {
  // debugger
  if (response.data && response.status === 200)
    return fetchPermissionsByUserIdSuccess(response.data);
  else return fetchPermissionsByUserIdError("An error occurred in adding admin user");
};

export const emptyUserRole = () => ({
  type: EMPTY_USER_ROLE,
});
export const fetchPermissionsByUserIdError = (Message = "") => ({
  type: FETCH_PERMISSIONS_BY_USERID_ERROR,
});
export const fetchPermissionsByUserIdSuccess = (response) => {
  if (typeof response === "undefined") return emptyUser();
  else if (response.data === null) {
    // debugger
    return emptyUserRole();
  } else if (response.state > 0 && response.data)
    return {
      type: FETCH_PERMISSIONS_BY_USERID_SUCCESS,
      payload: response.data,
    };
  else return showUserMessage(response.msg);
};

export const loadingEditAdminUser = () => ({
  type: LOADING_EDIT_ADMIN_USER,
});

export const loadingAddAdminUser = () => ({
  type: LOADING_ADD_ADMIN_USER,
});

export const removeShowErrorMessage = () => ({
  type: REMOVE_SHOW_ERROR_MESSAGE,
});
export const removeShowSuccessMessage = () => ({
  type: REMOVE_SHOW_SUCESS_MESSAGE,
});

export const emptyUsers = () => ({
  type: EMPTY_USERS
})